export const anyOf = (...roles) => ({ auth: true, anyOf: roles.flat() });
export const publicRoute = () => ({ public: true });
export const authOnly = () => ({ auth: true });
